import { createResourceReducer, typedResourceService } from './resourceReducer'

const { reducer, actions, thunks } = createResourceReducer({
    sliceName: 'papers',
    label: 'Paper',
    service: typedResourceService('Paper'),
})

export const { appendResource: appendPaper, destroyResource: destroyPaper, changeResource: changePaper } = actions
export const { createResource: createPaper, initializeResources: initializePapers, deleteResource: deletePaper, updateResource: updatePaper, searchResources: searchPapers, refreshResource: refreshPaper } = thunks

export default reducer
